import { Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { AssetState } from "__graphql__/types";
import { DropDown } from "ui/DropDown/DropDown";
import { BodyM } from "ui/Typography/Typography";

import { MISSING_REASON_OPTIONS } from "../utils/constants";

export function BatteryReportDropdown({
  model,
  id,
  setSelectedReason,
  selectedReason,
}: {
  model: string;
  id: string;
  setSelectedReason: (reason: AssetState) => void;
  selectedReason: null | AssetState;
}) {
  return (
    <Flex p="s200" direction="column" gap="s200" borderRadius="sm" bg="white" w="full">
      <BodyM noOfLines={1} wordBreak="break-all">
        <strong>{model}</strong> {id}
      </BodyM>
      <DropDown
        options={MISSING_REASON_OPTIONS}
        value={selectedReason}
        onInput={(reason) => {
          setSelectedReason(reason as AssetState);
        }}
        filterMode={false}
        border="1px solid"
        borderColor="grey.800"
        borderRadius="8px"
        bgColor="white"
        titleColor="grey.800"
        w="100%"
        h="40px"
        placement="top"
        listStyles={{ w: "320px", maxH: "260px" }}
        listItemStyles={{ w: "320px", minHeight: "40px" }}
      >
        <BodyM color="grey.800">
          <FormattedMessage id="pages.inventory.battery-count-page.cards.battery-status-reason.placeholder" />
        </BodyM>
      </DropDown>
    </Flex>
  );
}
